import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(en);

type CountryOption = { value: string; label: string };

/** True only for an uppercase ISO 3166-1 alpha-2 code that i18n-iso-countries recognizes. */
export function isValidCountryCode(code: string): boolean {
  return /^[A-Z]{2}$/.test(code) && countries.isValid(code);
}

/** Country options for admin selects, sorted by English name. Values are alpha-2 codes. */
export function getCountryOptions(): CountryOption[] {
  const names = countries.getNames('en', { select: 'official' });
  return Object.entries(names)
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
